module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_39.07428c45.png";